const steps = [
  {
    num: "01",
    icon: "ri-barcode-line",
    title: "Enter Tracking Number",
    desc: "Type your SE- tracking number into the search bar on our homepage.",
    accent: "from-emerald-400 to-teal-500",
    light: "bg-emerald-50",
    text: "text-emerald-600",
  },
  {
    num: "02",
    icon: "ri-map-pin-2-line",
    title: "View Live Location",
    desc: "See your parcel's current location on an interactive map in real time.",
    accent: "from-sky-400 to-cyan-500",
    light: "bg-sky-50",
    text: "text-sky-600",
  },
  {
    num: "03",
    icon: "ri-truck-line",
    title: "Track Every Step",
    desc: "Follow the complete journey from origin to your doorstep with a detailed timeline.",
    accent: "from-amber-400 to-orange-500",
    light: "bg-amber-50",
    text: "text-amber-600",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-24 relative overflow-hidden bg-slate-900">
      {/* Background texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: "radial-gradient(circle, white 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />
      {/* Top glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-40 opacity-20 pointer-events-none" style={{ background: "radial-gradient(ellipse, #34d399 0%, transparent 70%)" }} />

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest text-emerald-400 uppercase mb-3 bg-emerald-400/10 border border-emerald-400/20 px-4 py-1.5 rounded-full">
            Simple Process
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">How It Works</h2>
          <p className="text-slate-400 text-sm max-w-md mx-auto">
            Track your parcel in three simple steps — no registration required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connector line desktop */}
          <div className="hidden md:block absolute top-12 left-[calc(16.67%+2rem)] right-[calc(16.67%+2rem)] h-px bg-gradient-to-r from-emerald-500/40 via-sky-500/40 to-amber-500/40" />

          {steps.map((step, idx) => (
            <div key={idx} className="flex flex-col items-center text-center group">
              {/* Icon circle */}
              <div className="relative mb-6">
                <div className={`w-24 h-24 flex items-center justify-center rounded-full bg-gradient-to-br ${step.accent} shadow-lg`}>
                  <i className={`${step.icon} text-3xl text-white`} />
                </div>
                {/* Step number badge */}
                <span className="absolute -top-1 -right-1 w-7 h-7 flex items-center justify-center rounded-full bg-slate-800 border-2 border-slate-700 text-white text-xs font-bold">
                  {idx + 1}
                </span>
              </div>

              <div className="bg-slate-800/60 border border-slate-700/60 rounded-2xl p-6 w-full backdrop-blur-sm group-hover:border-slate-600 transition-colors duration-300">
                <h3 className="font-semibold text-white mb-2 text-base">{step.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA strip */}
        <div className="mt-16 text-center">
          <p className="text-slate-400 text-sm mb-4">Ready to track your parcel?</p>
          <a
            href="#track-section"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById("track-section");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold rounded-xl transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line" />
            </div>
            Track a Parcel Now
          </a>
        </div>
      </div>
    </section>
  );
}
